import React from "react";
import { DashboardRole, UserProfile } from "../auth/session";

interface DashboardHeaderProps {
  user: UserProfile;
  activeRole: DashboardRole;
  onRoleChange: (role: DashboardRole) => void;
  onLogout: () => void;
}

const ROLE_LABELS: Record<DashboardRole, string> = {
  student: "Student / Player",
  parent: "Parent / Guardian",
  coach: "Coach Workspace",
  academy: "Academy / Organization",
};

export function DashboardHeader({
  user,
  activeRole,
  onRoleChange,
  onLogout,
}: DashboardHeaderProps): React.JSX.Element {
  return (
    <header className="dashboard-header" role="banner">
      <div className="dashboard-header-left">
        <div className="portal-brand">
          <span className="brand-logo-icon" aria-hidden="true">
            ♞
          </span>
          <div className="brand-titles">
            <span className="brand-name">Zhatura</span>
            <span className="portal-subtitle">Unified Web Portal</span>
          </div>
        </div>

        <nav className="role-switcher-nav" aria-label="Role switcher">
          <span className="role-switcher-label">Active Workspace:</span>
          <div className="role-tabs">
            {(["student", "parent", "coach", "academy"] as const).map(
              (role) => (
                <button
                  key={role}
                  type="button"
                  className={`role-tab-btn ${activeRole === role ? "active" : ""}`}
                  onClick={() => onRoleChange(role)}
                  aria-pressed={activeRole === role}
                >
                  {ROLE_LABELS[role]}
                </button>
              ),
            )}
          </div>
        </nav>
      </div>

      <div className="dashboard-header-right">
        {user.isDemo && (
          <span
            className="demo-mode-badge"
            title="Running in synthetic evaluation persona mode with deterministic test data"
          >
            DEMO PERSONA
          </span>
        )}
        <div className="user-profile-badge">
          <span className="user-avatar" aria-hidden="true">
            {user.displayName.charAt(0).toUpperCase()}
          </span>
          <div className="user-details">
            <span className="user-display-name">{user.displayName}</span>
            <span className="user-territory">{user.territory}</span>
          </div>
        </div>

        <button
          type="button"
          className="btn-secondary btn-sm logout-btn"
          onClick={onLogout}
          aria-label="Sign out of Zhatura"
        >
          Sign Out
        </button>
      </div>
    </header>
  );
}
